<template>
  <div
    v-if="order.order_type === 'delivery' && (order.delivery_address || order.selected_address || order.customer)"
    class="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800"
  >
    <h4 class="text-sm font-medium text-blue-800 dark:text-blue-200 mb-2 flex items-center gap-2">
      <svg
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
      {{ $t('app.views.orders.modals.new_order.delivery_address') || 'Dirección de Entrega' }}
    </h4>
    <div class="space-y-1 text-sm text-blue-700 dark:text-blue-300">
      <!-- Priority: Use delivery_address field directly -->
      <p
        v-if="order.delivery_address"
        class="whitespace-pre-line"
      >
        {{ order.delivery_address }}
      </p>
      <!-- Second priority: Use selected_address -->
      <p
        v-else-if="order.selected_address && order.selected_address.full_address"
        class="whitespace-pre-line"
      >
        {{ order.selected_address.full_address }}
      </p>
      <!-- Fallback: Use customer data -->
      <p
        v-else-if="order.customer && getDeliveryAddress(order.customer)"
        class="whitespace-pre-line"
      >
        {{ getDeliveryAddress(order.customer) }}
      </p>
      <!-- No address available -->
      <p
        v-else
        class="text-blue-600 dark:text-blue-400 italic"
      >
        No hay dirección de entrega disponible
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  order: {
    order_type?: string
    delivery_address?: string
    selected_address?: {
      full_address?: string
      address?: string
      apartment?: string
      neighborhood?: string
      city?: string
      postal_code?: string
      reference_point?: string
    }
    customer?: any
  }
}

const props = defineProps<Props>()
const { t } = useI18n()

const getDeliveryAddress = (customer: any) => {
  if (!customer) return ''
  
  // Try different address field combinations
  if (customer.address) return customer.address
  if (customer.delivery_address) return customer.delivery_address
  if (customer.street) {
    const parts = [customer.street]
    if (customer.city) parts.push(customer.city)
    if (customer.state) parts.push(customer.state)
    if (customer.zip_code) parts.push(customer.zip_code)
    return parts.join(', ')
  }
  
  return ''
}
</script>
